import { render, staticRenderFns } from "./accountDetails.vue?vue&type=template&id=4c4fdf62&scoped=true"
import script from "./accountDetails.vue?vue&type=script&lang=js"
export * from "./accountDetails.vue?vue&type=script&lang=js"
import style0 from "./accountDetails.vue?vue&type=style&index=0&id=4c4fdf62&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4fdf62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c4fdf62')) {
      api.createRecord('4c4fdf62', component.options)
    } else {
      api.reload('4c4fdf62', component.options)
    }
    module.hot.accept("./accountDetails.vue?vue&type=template&id=4c4fdf62&scoped=true", function () {
      api.rerender('4c4fdf62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/basicData/branchAccounts/cmp/accountDetails.vue"
export default component.exports